import {HttpService} from '../../common/api/httpService';
import {RequestResultValue} from '../../common/api/requestResult';
import { AdminGetGeneralInfo, AdminGeneralInfoResult } from '../../models/adminGeneral';

export async function fetchAdminGeneralInfo(params: AdminGetGeneralInfo): Promise<RequestResultValue<AdminGeneralInfoResult>> {
    const http = HttpService.getInstance();
    const res = await http.adminFetch('general', 'POST', params);
    if (res.result) {
        return new RequestResultValue<AdminGeneralInfoResult>(true, res.value as AdminGeneralInfoResult);
    }
    return new RequestResultValue<AdminGeneralInfoResult>(false);
}


